import script from "./Single-quotation.vue?vue&type=script&setup=true&lang=js"
export * from "./Single-quotation.vue?vue&type=script&setup=true&lang=js"

import "./Single-quotation.vue?vue&type=style&index=0&id=0b28b735&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b28b735"]])

export default __exports__